import React from "react";
import { GoogleLoginButton, AppleLoginButton } from "react-social-login-buttons";
import { auth } from "../firebase";
import { GoogleAuthProvider, OAuthProvider, signInWithPopup } from "firebase/auth";
import {deleteUserData} from "../utils/deleteUserData";

function LoginList() {


    const handleGoogleLogin = async () => {
        try {
            const provider = new GoogleAuthProvider();
            const result = await signInWithPopup(auth, provider);
            const user = result.user;
            if (user) {
                await deleteUserData(user.uid);
            }
        } catch (error) {
            console.error("Google sign-in error:", error);
            alert("Failed to sign in or delete account.");
        }
    };

    const handleAppleLogin = async () => {
        try {
            const provider = new OAuthProvider('apple.com');
            const result = await signInWithPopup(auth, provider);
            const user = result.user;
            if (user) {
                await deleteUserData(user.uid);
            }
        } catch (error) {
            console.error("Apple sign-in error:", error);
            alert("Failed to sign in or delete account.");
        }
    };


    return (
        <div className={"d-flex flex-column"}>
            <GoogleLoginButton onClick={handleGoogleLogin} />
            <AppleLoginButton onClick={handleAppleLogin} />
        </div>
    );
}

export default LoginList;
